/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { MDIStrictHttpResponse } from '../../mdi-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { NappiCodeListModel } from '../../models/nappi-code-list-model';

export interface MasterDataNappiCodeLookupByValueGet$Params {
  value?: string;
  maxResults?: number;
}

export function masterDataNappiCodeLookupByValueGet(http: HttpClient, rootUrl: string, params?: MasterDataNappiCodeLookupByValueGet$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<Array<NappiCodeListModel>>> {
  const rb = new RequestBuilder(rootUrl, masterDataNappiCodeLookupByValueGet.PATH, 'get');
  if (params) {
    rb.query('value', params.value, {});
    rb.query('maxResults', params.maxResults, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as MDIStrictHttpResponse<Array<NappiCodeListModel>>;
    })
  );
}

masterDataNappiCodeLookupByValueGet.PATH = '/MasterData/NappiCodeLookupByValue';
